import { TextFieldProps } from '@mui/material';
import { FormMaskedTextField } from './FormMaskedTextField';
import type { Control, FieldValues, Path, RegisterOptions } from 'react-hook-form';

const PHONE_MASK = '(###) ###-####';

type FormPhoneFieldProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
} & Omit<TextFieldProps, 'name' | 'pattern' | 'required' | 'value' | 'defaultValue'>;

export const FormPhoneField = <TFieldValues extends FieldValues>({
  name,
  control,
  ...restProps
}: FormPhoneFieldProps<TFieldValues>) => {
  return <FormMaskedTextField name={name} control={control} mask={PHONE_MASK} type="tel" {...restProps} />;
};
